var map = {
	"./localhost/clientSettings.json": 67,
	"./nikkaren.ra-abas.jp/clientSettings.json": 68,
	"./saison.ra-abas.jp/clientSettings.json": 69,
	"./sompo-direct.ra-abas.jp/clientSettings.json": 70,
	"./sompo-japan.ra-abas.jp/clientSettings.json": 71,
	"./template/clientSettings.json": 72,
	"./zenjikyo.ra-abas.jp/clientSettings.json": 73
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18;